/**
 * Everything a user can do is done via a permission
 * Permission naming conventions
 * IDENTIFIER + ACTION
 * IDENTIFIER = {(COMPONENT||PAGE||CONTROLLER)}
 * concat with _
 * COMPONENT||PAGE -> look at angular structure
 * ACTION:
 *    VIEW -> SEEING STUFF
 *    EDIT -> CREATE UPDATE DELETE
 *    ADMIN -> CHANGE SYSTEM BEHAVIOUR
 *    CHOOSE -> ..
 *    SAVE -> ...
 */

const PERMISSIONS = {
  PLATFORM_VIEW: 'PLATFORM_VIEW',
  LOGOUT_VIEW: 'LOGOUT_VIEW',
  GARBAGE_VIEW: 'GARBAGE_VIEW',
  PROFILE_VIEW: 'PROFILE_VIEW',
  MYREPORTS_VIEW: 'MYREPORTS_VIEW',
  SHAREDWITHME_VIEW: 'SHAREDWITHME_VIEW',
  COLLECTIONS_VIEW: 'COLLECTIONS_VIEW',
  SIGNUP_VIEW: 'SIGNUP_VIEW',
  PAYMENT_VIEW: 'PAYMENT_VIEW',
  PAYMENT_SETTINGS: 'PAYMENT_SETTINGS',
  NOTIFICATION_VIEW: 'NOTIFICATION_VIEW',
  CREATOR_VIEW: 'CREATOR_VIEW', //is the plus shown in the header
  LANGUAGE_VIEW: 'LANGUAGE_VIEW',
  LANGUAGE_EDIT: 'LANGUAGE_EDIT',

  COLLECTION_CREATE: 'COLLECTION_CREATE',
  ATLAS_CREATE: 'ATLAS_CREATE',
  REPORT_CREATE: 'REPORT_CREATE',
  DATA_CREATE: 'DATA_CREATE',
  CONTENT_SAVE: 'CONTENT_SAVE',
  CONTENT_DOWNLOAD_SVG: 'CONTENT_DOWNLOAD_SVG',
  CONTENT_DOWNLOAD_GEOJSON: 'CONTENT_DOWNLOAD_GEOJSON',
  CONTENT_DOWNLOAD_PNG: 'CONTENT_DOWNLOAD_PNG',
  CONTENT_DOWNLOAD_CSV: 'CONTENT_DOWNLOAD_CSV',
  CONTENT_DOWNLOAD_XLS: 'CONTENT_DOWNLOAD_XLS',
  TEMPLATES_VIEW: 'TEMPLATES_VIEW',
  TEMPLATES_EDIT: 'TEMPLATES_EDIT',
  LAYOUT_VIEW: 'LAYOUT_VIEW',
  LAYOUT_EDIT: 'LAYOUT_EDIT',
  MAP_LAYER_VIEW: 'MAP_LAYER_VIEW',
  MAP_LAYER_EDIT: 'MAP_LAYER_EDIT',
  ADVANCED_TOOLTIP_ADDIMAGESFROMDATA: 'ADVANCED_TOOLTIP_ADDIMAGESFROMDATA',
  ADVANCED_TOOLTIP_ADDLINKSFROMDATA: 'ADVANCED_TOOLTIP_ADDLINKSFROMDATA',
  DESCRIPTION_ADDVALUEFROMDATA: 'DESCRIPTION_ADDVALUEFROMDATA',
  COPY_SLUG: 'COPY_SLUG',
  EMBED: 'EMBED',
  APPLY_UPDATE: 'APPLY_UPDATE',
  CONTENT_REUSAGE: 'CONTENT_REUSAGE',

  COLOREDITOR_VIEW: 'COLOREDITOR_VIEW',
  COLOREDITOR_EDIT: 'COLOREDITOR_EDIT',
  SMARTFUNCTIONS_VIEW: 'SMARTFUNCTIONS_VIEW',
  CONTENT_PRIVATE: 'CONTENT_PRIVATE',
  CONTENT_LINKSHARE: 'CONTENT_LINKSHARE',
  LOGO_UPLOAD: 'LOGO_UPLOAD',
  LOGO_EDIT: 'LOGO_EDIT',

  SIMPLIFY_2MB: 'SIMPLIFY_2MB',
  SIMPLIFY_4MB: 'SIMPLIFY_4MB',

  USERMANAGEMENT_VIEW: 'USERMANAGEMENT_VIEW',
  USERMANAGEMENT_EDIT: 'USERMANAGEMENT_EDIT',
  TAGMANAGEMENT_VIEW: 'TAGMANAGEMENT_VIEW',
  TAGMANAGEMENT_EDIT: 'TAGMANAGEMENT_EDIT',
  TAG_VIEW: 'TAG_VIEW',

  COMMERCIAL_PUBLISHING: 'COMMERCIAL_PUBLISHING',

  COMMERCIALS_VIEW: 'COMMERCIALS_VIEW',
  COMMERCIALS_EDIT: 'COMMERCIALS_EDIT',

  NO_UPSELLING: 'NO_UPSELLING',

  SLA: 'SLA',
  API: 'API',
  API_GET: 'API_GET',

  //edit tags of your content
  TAG_EDIT: 'TAG_EDIT',
  //can edit tags of other people -- special button
  TAG_EDIT_ADMIN: 'TAG_EDIT_ADMIN',

  CUSTOM_ANNOTATION_SHAPES: 'CUSTOM_ANNOTATION_SHAPES',
  DEFAULT_LAYERS: 'DEFAULT_LAYERS',
  TAGESSCHAU_LAYERS: 'TAGESSCHAU_LAYERS',
  KLZ_LAYERS: 'KLZ_LAYERS',
  RP_LAYERS: 'RP_LAYERS',

  EZ_VISUAL: 'EZ_VISUAL',
  GEOLAYERS_EXPORT: 'GEOLAYERS_EXPORT',
  CHART_LAB: 'CHART_LAB',
  TT_LINE_CHART: 'TT_LINE_CHART',
  ECHARTS_SANKEY: 'ECHARTS_SANKEY',

  CONTENT_BULKPDF: 'CONTENT_BULKPDF',
  CONTENT_BULKPDF_VIEW: 'CONTENT_BULKPDF_VIEW', // remove after client approval
  CONTENT_CHANGE_ACCESS_ACTION: 'CONTENT_CHANGE_ACCESS_ACTION',

  DATACORE_VIEW: 'DATACORE_VIEW',

  TUTORIAL_PAGE_VIEW: 'TUTORIAL_PAGE_VIEW',
  TUTORIAL_PAGE_ADMIN: 'TUTORIAL_PAGE_ADMIN',

  CREATE_BLANK_MAP: 'CREATE_BLANK_MAP',

  HIDE_ON_EXPORT: 'HIDE_ON_EXPORT',

  STREAM_ADMIN: 'STREAM_ADMIN',

  CONTENT_STATUS: 'CONTENT_STATUS',
  CONDITIONAL_REFERENCE: 'CONDITIONAL_REFERENCE',

  NO_SCRIPTS: 'NO_SCRIPTS',

  NEW_CONTENT_PAGE: 'NEW_CONTENT_PAGE',
  DEBUG_MODE: 'DEBUG_MODE',
  MULTI_MAP: 'MULTI_MAP',
  DASHBOARD: 'DASHBOARD',
  MINI_MAP: 'MINI_MAP',
  MEDIA_LIBRARY: 'MEDIA_LIBRARY',
  HOVER_TOOLTIP: 'HOVER_TOOLTIP',
  MAP_ADDRESS_SEARCH: 'MAP_ADDRESS_SEARCH'

} as const;

const ANON_USER = {
  id: '5d4858873a75ba001db8de2c',
  token:
    'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJfaWQiOiI1ZDQ4NTg4NzNhNzViYTAwMWRiOGRlMmMiLCJlbWFpbCI6ImFub25AMjNkZWdyZWVzLmlvIiwic2x1ZyI6ImFub255bW91cy0xIiwicm9sZXMiOlsiNWQ0OGFiYzU4MzE4NmMwMDFlZjZjNzhlIl0sImV4cCI6MTU5MTYxNDI5MSwiaWF0IjoxNTkxNjE0MjkxfQ.SxNLq5Ab_ioizMXDO9iIPXLuwJE7ccKj1qe7SKEk22U',
} as const;

export { PERMISSIONS, ANON_USER };
